import React from 'react'
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:300,
  //height:150,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderColor: "primary.light",
  verticalAlign: "middle",
  display: "table-cell",
  //boxShadow: 20,
  p: 2, //padding 설정
};


function IpgoError(props) {
  return (
    <div>
      <Modal open={props.eerror}>
        <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2" style={{color: "Red", textAlign:'center'}}>
          -입고등록ERROR-
        </Typography>
        <Typography id="modal-modal-description" >
          입고등록 저장이 실패했습니다.<br/>[확인사항: <strong>로그인 인증</strong>을 다시해보세요].
        </Typography>
            <Button onClick={() => { props.setEerror(false)}} 
                variant="outlined"
                style={{
                  background:'#388e3c',
                  color:'white',
                  height: "30px",
                  width: 90,
                  marginTop: "10px",
                  float: "right",
                }}>닫기</Button>
        </Box>
      </Modal>

    </div>
  )
}

export default IpgoError